import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import { useFormikContext } from 'formik';

import type { FormFieldKeys } from './constants';

interface ActionButtonsProps {
  disabled?: boolean;
}

const ActionButtons: FC<ActionButtonsProps> = ({ disabled = false }) => {
  const { values } = useFormikContext<FormFieldKeys>();
  const { t } = useTranslation('followUp');
  return (
    <Box
      sx={{
        width: '100%',
        display: values.callHappened ? 'flex' : 'none',
        gap: 2,
      }}
    >
      <Button
        type="reset"
        variant="cta"
        color="secondary"
        fullWidth
        disabled={disabled}
      >
        {t('cancel')}
      </Button>
      <Button type="submit" fullWidth disabled={disabled}>
        {t('save')}
      </Button>
    </Box>
  );
};

export default ActionButtons;
